iScreenWizard.factory('Groepscode', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('groepscode', params).then(function (response) {
                var groepscodes = response.data;
                resolve(groepscodes);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('groepscode/'+id).then(function (response) {
                var groepscode = response.data;
                resolve(groepscode);
            }, reject);
        });
    };

    return data;
});